// import React, { useRef } from 'react'
// import html2canvas from 'html2canvas'
// import jsPDF from 'jspdf'

// const SalaryCard = ({ data }) => {
//   const {
//     name,
//     work_id,
//     email,
//     post,
//     phone_number,
//     profile_pic,
//     month,
//     year,
//     basic_salary,
//     da_percentage,
//     gross_salary,
//     net_salary,
//     present_days,
//     working_days,
//     cl_taken,
//     ml_taken,
//     el_taken,

//     epf,

//     tax,
//     bonus,
//     penalty,
//     payment_date,
//     payment_mode,
//     remark,

//     holidays,
//   } = data

//   const pdfRef = useRef()

//   const downloadPDF = async () => {
//     const element = pdfRef.current
//     const canvas = await html2canvas(element)
//     const data = canvas.toDataURL('image/png')

//     const pdf = new jsPDF('p', 'mm', 'a4')
//     const imgProperties = pdf.getImageProperties(data)
//     const pdfWidth = pdf.internal.pageSize.getWidth()
//     const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width

//     pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight)
//     pdf.save(`${name}_salary_slip_${month}_${year}.pdf`)
//   }

//   return (
//     <div className='relative'>
//       <div className='absolute top-4 right-4 md:right-10 lg:right-36 z-10'>
//         <button
//           onClick={downloadPDF}
//           className='bg-blue-600 text-black px-4 py-2 rounded-lg  transition-colors flex items-center gap-2 '
//         >
//           <svg
//             xmlns='http://www.w3.org/2000/svg'
//             className='h-5 w-5'
//             fill='none'
//             viewBox='0 0 24 24'
//             stroke='currentColor'
//           >
//             <path
//               strokeLinecap='round'
//               strokeLinejoin='round'
//               strokeWidth={2}
//               d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4'
//             />
//           </svg>
//           Download PDF
//         </button>
//       </div>

//       <div
//         ref={pdfRef}
//         className='max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-lg'
//       >
//         {/* Rest of your existing component code remains exactly the same */}
//         {/* Header */}
//         <div className='text-center mb-6'>
//           <h2 className='text-2xl font-bold text-gray-800'>Salary Slip</h2>
//           <p className='text-lg text-gray-600'>
//             {month} {year}
//           </p>
//         </div>

//         {/* Employee Info Section */}
//         <div className='flex flex-col md:flex-row gap-6 mb-8'>
//           <div className='w-32 h-32 mx-auto md:mx-0 rounded-full border-4 border-blue-100 shadow-lg overflow-hidden hover:scale-105 transition-transform duration-300'>
//             <img
//               src={
//                 profile_pic ||
//                 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
//               }
//               alt='profile'
//               className='h-full w-full object-cover'
//             />
//           </div>
//           <div className='flex-1'>
//             <table className='w-full border-collapse'>
//               <tbody>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium w-1/3'>
//                     Employee Name
//                   </td>
//                   <td className='py-2 px-4'>{name}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>Work ID</td>
//                   <td className='py-2 px-4'>{work_id}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>Position</td>
//                   <td className='py-2 px-4'>{post}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>Email</td>
//                   <td className='py-2 px-4'>{email}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>Phone</td>
//                   <td className='py-2 px-4'>{phone_number}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Salary Details */}
//         <div className='mb-8'>
//           <h3 className='text-lg font-semibold mb-4 text-gray-700 border-b pb-2'>
//             Salary Details
//           </h3>
//           <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
//             <table className='w-full border-collapse bg-white rounded-lg overflow-hidden'>
//               <tbody>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Basic Salary
//                   </td>
//                   <td className='py-2 px-4 text-right'>₹{basic_salary}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     DA Percentage
//                   </td>
//                   <td className='py-2 px-4 text-right'>{da_percentage}%</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Gross Salary
//                   </td>
//                   <td className='py-2 px-4 text-right'>₹{gross_salary}</td>
//                 </tr>
//                 <tr className='border-b bg-blue-50'>
//                   <td className='py-2 px-4 font-medium text-blue-700'>
//                     Net Salary
//                   </td>
//                   <td className='py-2 px-4 text-right font-bold text-blue-700'>
//                     ₹{net_salary}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>

//             <table className='w-full border-collapse bg-white rounded-lg overflow-hidden'>
//               <tbody>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>epf</td>
//                   <td className='py-2 px-4 text-right'>₹{epf}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>Tax</td>
//                   <td className='py-2 px-4 text-right'>₹{tax}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>bonus</td>
//                   <td className='py-2 px-4 text-right text-green-600'>
//                     ₹{bonus}
//                   </td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>penalty</td>
//                   <td className='py-2 px-4 text-right text-red-600'>
//                     ₹{penalty}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Attendance Details */}
//         <div className='mb-8'>
//           <h3 className='text-lg font-semibold mb-4 text-gray-700 border-b pb-2'>
//             Attendance Details
//           </h3>
//           <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
//             <table className='w-full border-collapse bg-white rounded-lg overflow-hidden'>
//               <tbody>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Working Days
//                   </td>
//                   <td className='py-2 px-4 text-right'>{working_days}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Present Days
//                   </td>
//                   <td className='py-2 px-4 text-right'>{present_days}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>holidays</td>
//                   <td className='py-2 px-4 text-right'>{holidays}</td>
//                 </tr>
//               </tbody>
//             </table>

//             <table className='w-full border-collapse bg-white rounded-lg overflow-hidden'>
//               <tbody>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Casual Leave (CL)
//                   </td>
//                   <td className='py-2 px-4 text-right'>{cl_taken}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Medical Leave (ML)
//                   </td>
//                   <td className='py-2 px-4 text-right'>{ml_taken}</td>
//                 </tr>
//                 <tr className='border-b'>
//                   <td className='py-2 px-4 bg-gray-50 font-medium'>
//                     Earned Leave (EL)
//                   </td>
//                   <td className='py-2 px-4 text-right'>{el_taken}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Payment Details */}
//         <div className='mb-4'>
//           <h3 className='text-lg font-semibold mb-4 text-gray-700 border-b pb-2'>
//             Payment Details
//           </h3>
//           <table className='w-full border-collapse bg-white rounded-lg overflow-hidden'>
//             <tbody>
//               <tr className='border-b'>
//                 <td className='py-2 px-4 bg-gray-50 font-medium'>
//                   Payment Date
//                 </td>
//                 <td className='py-2 px-4'>{payment_date}</td>
//               </tr>
//               <tr className='border-b'>
//                 <td className='py-2 px-4 bg-gray-50 font-medium'>
//                   Payment Mode
//                 </td>
//                 <td className='py-2 px-4'>{payment_mode}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* remarks */}
//         {remark && (
//           <div className='mt-6 p-4 bg-yellow-50 rounded-lg'>
//             <p className='font-medium text-gray-700 mb-1'>remarks</p>
//             <p className='text-gray-600'>{remark}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   )
// }

// export default SalaryCard
// ***********************2*********************************

import React, { useState, useRef } from 'react'
import {
  FiChevronDown,
  FiChevronUp,
  FiDownload,
  FiEdit,
  FiTrash2,
} from 'react-icons/fi'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const SalaryCard = ({ salary, onEdit, onDelete }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const pdfRef = useRef()

  const formatCurrency = (amount) => {
    return `₹${parseFloat(amount).toLocaleString('en-IN')}`
  }

  const downloadPDF = async () => {
    try {
      // Create a temporary div for PDF content
      const pdfContent = document.createElement('div')
      pdfContent.style.padding = '20px'
      pdfContent.innerHTML = `
        <h2 style="text-align: center; margin-bottom: 20px;">Salary Slip</h2>
        <div style="margin-bottom: 20px;">
          <p><strong>Name:</strong> ${salary.name}</p>
          <p><strong>Employee ID:</strong> ${salary.work_id}</p>
          <p><strong>Month:</strong> ${salary.month} ${salary.year}</p>
        </div>
        <div style="margin-bottom: 20px;">
          <h3 style="margin-bottom: 10px;">Salary Details</h3>
          <p><strong>Basic Salary:</strong> ${formatCurrency(
            salary.basic_salary
          )}</p>
          <p><strong>Gross Salary:</strong> ${formatCurrency(
            salary.gross_salary
          )}</p>
          <p><strong>Net Salary:</strong> ${formatCurrency(
            salary.net_salary
          )}</p>
          <p><strong>EPF:</strong> ${formatCurrency(salary.epf)}</p>
          <p><strong>Tax:</strong> ${formatCurrency(salary.tax)}</p>
          <p><strong>Bonus:</strong> ${formatCurrency(salary.bonus)}</p>
        </div>
        <div>
          <h3 style="margin-bottom: 10px;">Attendance</h3>
          <p><strong>Working Days:</strong> ${salary.working_days}</p>
          <p><strong>Present Days:</strong> ${salary.present_days}</p>
          <p><strong>Payment Status:</strong> ${
            salary.payment_done ? 'Paid' : 'Pending'
          }</p>
        </div>
      `

      document.body.appendChild(pdfContent)

      const canvas = await html2canvas(pdfContent)
      document.body.removeChild(pdfContent)

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${salary.name}_salary_slip_${salary.month}_${salary.year}.pdf`)
    } catch (error) {
      console.error('Error generating PDF:', error)
      alert('Failed to generate PDF. Please try again.')
    }
  }

  // Condensed view of important details
  const CondensedView = () => (
    <div className='flex items-center justify-between p-4'>
      <div className='flex items-center space-x-4'>
        <img
          src={
            salary.profile_pic ||
            'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
          }
          alt={salary.name}
          className='w-12 h-12 rounded-full object-cover'
        />
        <div>
          <h3 className='font-medium'>{salary.name}</h3>
          <p className='text-sm text-gray-600'>ID: {salary.work_id}</p>
        </div>
      </div>

      <div className='flex items-center space-x-4'>
        <div className='text-right mr-4'>
          <div className='font-medium'>{formatCurrency(salary.net_salary)}</div>
          <div className='text-sm text-gray-600'>
            {salary.month} {salary.year}
          </div>
        </div>
        <div className='flex items-center space-x-2'>
          <button
            onClick={(e) => {
              e.stopPropagation()
              downloadPDF()
            }}
            className='p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-100'
          >
            <FiDownload size={20} />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation()
              setIsExpanded(!isExpanded)
            }}
            className='p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-100'
          >
            {isExpanded ? (
              <FiChevronUp size={20} />
            ) : (
              <FiChevronDown size={20} />
            )}
          </button>
        </div>
      </div>
    </div>
  )

  // Rest of your component code...
  return (
    <div className='border rounded-lg bg-white mb-4 shadow-sm'>
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className='cursor-pointer hover:bg-gray-50 transition-colors'
      >
        <CondensedView />
      </div>

      {isExpanded && (
        <div className='border-t'>
          <div className='p-4'>
            <div className='grid grid-cols-2 md:grid-cols-3 gap-4 mb-6'>
              <DetailItem
                label='Basic Salary'
                value={formatCurrency(salary.basic_salary)}
              />
              <DetailItem
                label='Gross Salary'
                value={formatCurrency(salary.gross_salary)}
              />
              <DetailItem
                label='Net Salary'
                value={formatCurrency(salary.net_salary)}
              />
              <DetailItem label='EPF' value={formatCurrency(salary.epf)} />
              <DetailItem label='Tax' value={formatCurrency(salary.tax)} />
              <DetailItem label='Bonus' value={formatCurrency(salary.bonus)} />
              <DetailItem label='Working Days' value={salary.working_days} />
              <DetailItem label='Present Days' value={salary.present_days} />
              <DetailItem
                label='Payment Status'
                value={salary.payment_done ? 'Paid' : 'Pending'}
              />
            </div>

            <div className='flex justify-end space-x-2 pt-4 border-t'>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  onEdit(salary.id)
                }}
                className='flex items-center gap-1 px-3 py-1.5 bg-tan text-white rounded hover:bg-tan/80'
              >
                <FiEdit size={16} />
                Edit
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  onDelete(salary.id)
                }}
                className='flex items-center gap-1 px-3 py-1.5 bg-rust text-white rounded hover:bg-rust/80'
              >
                <FiTrash2 size={16} />
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const DetailItem = ({ label, value }) => (
  <div className='bg-gray-50 p-3 rounded'>
    <div className='text-sm text-gray-600'>{label}</div>
    <div className='font-medium'>{value}</div>
  </div>
)

export default SalaryCard
